import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', loadComponent: () =>
        import('./login/loginPage/login-page.component').then(m => m.LoginPageComponent),
    canActivate: [AuthGuard]},
  {path: 'sso/initialize', loadComponent: () =>
        import('./sso/sso-initialize.component').then(m => m.SsoInitializeComponent)},
  {
    path: 'inventory', loadComponent: () =>
        import('./inventory/container/inventory-container.component').then(m => m.InventoryContainerComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'my-apps', loadComponent: () =>
        import('./myApps/container/my-apps-container.component').then(m => m.MyAppsContainerComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'publish', loadComponent: () =>
        import('./publish/container/publish-container.component').then(m => m.PublishContainerComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'troubleshooting', loadComponent: () =>
        import('./troubleshooting/troubleshooting.component').then(m => m.TroubleshootingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-urls', loadComponent: () =>
        import('./whitelist-URL/container/manage-url-container.component').then(m => m.ManageUrlContainerComponent),
    canActivate: [AuthGuard]
  },
  {path: '**', redirectTo: 'login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {paramsInheritanceStrategy: 'always'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
